import styled from "@emotion/styled";
import { FC } from "react";

import { MoreHoriz } from "@livechat/design-system-icons";
import { DesignToken, Icon, RadiusToken, SpacingToken, Text, Tooltip } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";
import { withVar } from "themes/helpers";

interface IProps {
  onClick: () => void;
  disabled?: boolean;
}

const tooltipContentMap = {
  available: "Show cut content",
  unavailable: "Cut content is no longer available to display",
};

export const ShowUnstrippedContentButton: FC<IProps> = ({ onClick, disabled }) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onShowCutContent = () => {
    onClick();
    trackEngagement("Tickets: Show cut content clicked", EventPlace.TicketDetails);
  };

  return (
    <Wrapper>
      <Tooltip
        triggerRenderer={() => (
          <StyledButton
            onClick={onShowCutContent}
            type="button"
            disabled={disabled}
            data-testid="show-cut-content-button"
            aria-label="Show cut content"
          >
            <Icon source={MoreHoriz} size="small" />
          </StyledButton>
        )}
        kind="invert"
      >
        <Text>{tooltipContentMap[disabled ? "unavailable" : "available"]}</Text>
      </Tooltip>
    </Wrapper>
  );
};

const StyledButton = styled.button`
  border: none;
  border-radius: ${withVar(RadiusToken.Radius3)};
  padding-inline: ${withVar(SpacingToken.Spacing1)};
  padding-block: 0;
  background-color: ${withVar(DesignToken.SurfaceTertiaryDefault)};

  :hover {
    background-color: ${withVar(DesignToken.SurfaceTertiaryHover)};
  }

  :active {
    background-color: ${withVar(DesignToken.SurfaceTertiaryActive)};
  }

  :disabled {
    background-color: ${withVar(DesignToken.SurfaceTertiaryDisabled)};
  }
`;

const Wrapper = styled.div`
  width: fit-content;
  height: fit-content;
`;
